import React, { createRef, FC, useEffect, useState, useContext } from "react";
// import SwipeableDrawer from '@bit/mui-org.material-ui.swipeable-drawer'
import { useLocation } from "react-router-dom";
import useDraft from "../../redux/draft-drawer/useDraft";
import { useWindowSize } from "../utils";
import {
  StyledDraftDrawer,
  DraftDrawerCaption,
  DraftDrawerHeader,
  DraftDrawerImage,
  DraftDrawerSelectors,
} from ".";
import { Button, Spinner } from "../System";
import { useDraftActions } from "../DraftsView";
import { QuickDraftClearModal, DraftShareModal } from "../Modals";
import { getImageDimensions } from "./getImageDimensions";
import { userStore } from "../utils/UserContext";

const DraftDrawer: FC = () => {
  const { user } = useContext(userStore);
  const location = useLocation();
  const scrollRef = createRef<HTMLDivElement>();
  const {
    isOpened,
    captionText,
    imageUrl,
    isSaved,
    postDate,
    socialProfiles,
    shareModal,
    actions: {
      openDraft,
      closeDraft,
      clearAndCloseDraft,
      setDraftImage,
      setDraftImageDimensions,
      clearImageDimensions,
      setShowShareModal,
    },
  } = useDraft();
  const {
    previewImage,
    loadingSave,
    handleSaveDraft,
    checkDraftDisabled,
    handlePreviewImage,
    setPreviewImage,
  } = useDraftActions();
  const { breakpoints } = useWindowSize();
  const [showClearModal, setShowClearModal] = useState(false);

  const closeDrawer = () => {
    if (isSaved) {
      clearAndCloseDraft();
      setPreviewImage(undefined);
      return;
    }

    setShowClearModal(true);
  };

  const handleImageUrl = async () => {
    const imageDimensions = await getImageDimensions(imageUrl || "");
    setDraftImageDimensions(imageDimensions.x, imageDimensions.y);
    openDraft();
  };

  useEffect(() => {
    if (previewImage) {
      setDraftImageDimensions(previewImage.imageX, previewImage.imageY);
      setDraftImage(previewImage.url);
    }
  }, [previewImage]);

  useEffect(() => {
    if (captionText) {
      openDraft();
    }
  }, [captionText]);

  useEffect(() => {
    if (imageUrl) {
      handleImageUrl();
      return;
    }

    clearImageDimensions();
  }, [imageUrl]);

  useEffect(() => {
    if (!breakpoints.includes("m")) {
      closeDraft();
    }
  }, [location.pathname]);

  return (
    <>
      {/* <SwipeableDrawer
        anchor="right"
        open={isOpened}
        variant={breakpoints.includes('l') ? 'persistent' : 'temporary'}
        onClose={() => closeDraft()}
        onOpen={() => openDraft()}
        disableDiscovery
        disableSwipeToOpen
        ModalProps={{ disableEnforceFocus: true }}
      > */}
      <StyledDraftDrawer>
        <div className="draft-drawer-top">
          <DraftDrawerHeader closeDrawer={() => closeDrawer()} />
          <DraftDrawerImage
            previewImage={previewImage}
            handlePreviewImage={(files) => handlePreviewImage(files)}
          />
          <DraftDrawerCaption scrollRef={scrollRef} />
          <DraftDrawerSelectors />
        </div>
        <div className="draft-drawer-actions">
          <Button
            type="small"
            theme="outline"
            disabled={checkDraftDisabled()}
            onClick={() => handleSaveDraft()}
            id="draft-drawer-save-btn"
          >
            {loadingSave ? <Spinner theme="blend" size="small" /> : "Save"}
          </Button>
          <Button
            disabled={checkDraftDisabled()}
            type="small"
            className="save-btn"
            onClick={() => setShowShareModal(true)}
          >
            Share
            <div className="beta-flag">BETA</div>
          </Button>
        </div>
      </StyledDraftDrawer>
      {/* </SwipeableDrawer> */}
      <QuickDraftClearModal
        isOpen={showClearModal}
        onClose={() => setShowClearModal(false)}
        onConfirm={() => {
          clearAndCloseDraft();
          setPreviewImage(undefined);
        }}
      />
      <DraftShareModal
        scheduledDate={postDate}
        profiles={
          shareModal?.isRescheduling
            ? user?.socialProfiles?.filter((p) =>
                socialProfiles?.includes(p._id!)
              )
            : undefined
        }
        isOpen={shareModal?.show}
        onClose={() => setShowShareModal(false)}
        onSave={(shouldClose, params) => handleSaveDraft(shouldClose, params)}
      />
    </>
  );
};

export default DraftDrawer;
